import { render, staticRenderFns } from "./HistoryDoctorDentistAll.vue?vue&type=template&id=9a79380a&scoped=true&"
import script from "./HistoryDoctorDentistAll.vue?vue&type=script&lang=js&"
export * from "./HistoryDoctorDentistAll.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDoctorDentistAll.vue?vue&type=style&index=0&id=9a79380a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a79380a",
  null
  
)

export default component.exports